import { StyledContent } from '@/components/styles';
import { Picture } from '@/components';

export default function Certificate({ certificate }) {
  const { title, image, content, preview_alt } = certificate.data;
  const imageAlt = preview_alt || title || '';
  return (
    <StyledContent.Certificate>
      <Picture {...image} alt={imageAlt} isLazy={true}/>
      <StyledContent.CertificateName>{title}</StyledContent.CertificateName>
      {content && (
        <StyledContent.CertificateText>
          <StyledContent.Html dangerouslySetInnerHTML={{ __html: content }} />
        </StyledContent.CertificateText>
      )}
    </StyledContent.Certificate>
  );
}
